import React from 'react'

const tool = () => {
  return (
    <div>tool</div>
  )
}

export default tool